module.exports = __webpack_public_path__ + "static/img/pergunta-canais.5528713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pergunta-canais.png
// module id = ygFY
// module chunks = 1